import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadRemoteModule } from "@cw-elements/mfe-setup/load";
import { useConfig } from "@cw-elements/config";
import i18n from "../../i18n";
import { useNewTrialState } from "../../pages/new-trail/hooks/NewTrialStateProvider";
import useFormHandling from "../../pages/new-trail/hooks/useFormHandling";
import { useTrialsRouter } from "../../shared/custom-hooks/useTrialsRouter";

const MachineryFieldOperations = React.lazy(async () => {
  return await loadRemoteModule("machinery-field-operations/index");
});

const currentLanguage = i18n.language;

export function MachineryFieldOperationsComponent({
  closeFieldOperationsDrawer,
}: Readonly<{
  closeFieldOperationsDrawer: () => void;
}>): JSX.Element {
  const { fieldData, form } = useFormHandling();
  const { setFieldOperationsData } = useNewTrialState();
  const { orgId } = useTrialsRouter();
  const config = useConfig();
  const props = {
    getConfigInstance: () => config,
    userLanguage: currentLanguage,
    orgId,
    fieldId: form.getFieldValue("field_ids") || fieldData?.[0]?.id,
    onClose: () => {
      closeFieldOperationsDrawer();
    },
    unitSystem: "metric",
    onSelect: (operation: any): any => {},
    onSelectImage: (image: any): any => {
      setFieldOperationsData(image);
    },
  };

  return (
    <div
      className="field-operations-container"
      data-testid="machinery-field-operations"
    >
      <ErrorBoundary fallback={<span></span>}>
        <React.Suspense fallback="">
          <MachineryFieldOperations {...props} />
        </React.Suspense>
      </ErrorBoundary>
    </div>
  );
}
